var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChickenCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.905605,
    y: 0.905605,
    width: 43.469,
    height: 43.469,
    rx: 21.7345,
    stroke: "#FCC436",
    strokeWidth: 1.81121
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.95 14.3857C26.95 14.3857 29.0641 10.8824 28.0977 10.3991C27.1312 9.91591 25.6816 10.8824 25.6816 10.8824C25.6816 10.8824 26.648 7.49979 24.7151 7.49979C22.7822 7.49979 22.299 9.43269 22.299 9.43269C22.299 9.43269 21.5949 5.42385 18.9164 6.53334C17.2425 7.22677 16.5003 8.94946 18.9164 13.7817",
    fill: "#FCC436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9049 24.1084C19.6551 24.1084 20.2633 23.5003 20.2633 22.75C20.2633 21.9998 19.6551 21.3916 18.9049 21.3916C18.1546 21.3916 17.5464 21.9998 17.5464 22.75C17.5464 23.5003 18.1546 24.1084 18.9049 24.1084Z",
    fill: "#FCC436"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.603 24.1084C28.3532 24.1084 28.9614 23.5003 28.9614 22.75C28.9614 21.9998 28.3532 21.3916 27.603 21.3916C26.8527 21.3916 26.2446 21.9998 26.2446 22.75C26.2446 23.5003 26.8527 24.1084 27.603 24.1084Z",
    fill: "#FCC436"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8717 24.291C22.8717 24.291 31.5697 23.8077 22.8717 32.989C22.8717 32.989 14.1736 24.291 22.8717 24.291Z",
    fill: "#FCC436"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.862 34.4387C22.9072 35.7963 22.9079 35.7963 22.9086 35.7963L22.9104 35.7962L22.9149 35.7961L22.928 35.7956L22.9695 35.7937C23.004 35.792 23.0518 35.7894 23.1118 35.7855C23.2319 35.7776 23.4012 35.7644 23.6108 35.7427C24.0292 35.6993 24.6128 35.6214 25.288 35.4822C26.6199 35.2078 28.3953 34.6777 29.9578 33.6361C31.5473 32.5764 32.9556 30.9547 33.3739 28.5563C33.782 26.2163 33.2083 23.3565 31.3474 19.8579C31.327 19.8067 31.2988 19.7382 31.2625 19.6548C31.187 19.4813 31.0758 19.2418 30.9254 18.9582C30.6261 18.3939 30.1637 17.6393 29.5075 16.8795C28.1898 15.3538 26.0317 13.7513 22.862 13.7513C19.6922 13.7513 17.5341 15.3538 16.2164 16.8795C15.5603 17.6393 15.0978 18.3939 14.7986 18.9582C14.6482 19.2418 14.5369 19.4813 14.4614 19.6548C14.4251 19.7382 14.3969 19.8067 14.3765 19.8579C12.5157 23.3565 11.9419 26.2163 12.35 28.5563C12.7684 30.9547 14.1766 32.5764 15.7661 33.6361C17.3287 34.6777 19.104 35.2078 20.436 35.4822C21.1111 35.6214 21.6948 35.6993 22.1131 35.7427C22.3227 35.7644 22.4921 35.7776 22.6121 35.7855C22.6721 35.7894 22.72 35.792 22.7544 35.7937L22.796 35.7956L22.809 35.7961L22.8135 35.7962L22.8153 35.7963C22.816 35.7963 22.8167 35.7963 22.862 34.4387ZM22.862 34.4387L22.8167 35.7963C22.8469 35.7973 22.8771 35.7973 22.9072 35.7963L22.862 34.4387Z",
    stroke: "#FCC436",
    strokeWidth: 2.71681,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenCat);
export default __webpack_public_path__ + "static/media/chickenCat.3222114ce6b21ba5c49496bc89d70cf5.svg";
export { ForwardRef as ReactComponent };